import { createClient } from '@supabase/supabase-js'

//const supabaseUrl = 'https://mmjxtfshoomezbbytwup.supabase.co'
//const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1tanh0ZnNob29tZXpiYnl0d3VwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU4ODQwMTQsImV4cCI6MjA1MTQ2MDAxNH0.unIKTCoBmiIADUbNmSoH08Z4ltR85DpdJc8QX6_rezk'
const supabaseUrl = 'https://crxymqpsyuxzppwkszty.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNyeHltcXBzeXV4enBwd2tzenR5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY4MzQwOTcsImV4cCI6MjA1MjQxMDA5N30.VmSOJFyP4Bx-xsdvdMyzN6SobPelKrmC3lsplIAsn18'
export const supabase = createClient(supabaseUrl, supabaseKey)
